<template>
  <input type="text" :id="id" :name="name" :class="classes" :style="styles" :title="title" :placeholder="placeholder"
         :value="value" @focus="onFocus" @blur="onBlur" @keyup="onKeyUp" @input="onInput" @change="setDisplayValue"/>
</template>
<script>
  export default {
    props: ['id', 'name', 'title', 'classes', 'placeholder', 'styles', 'value'],

    data: function () {
      return {
        focused: false
      }
    },

    watch: {
      value() {
        // No actualiza el valor mientras el elemento tenga el foco
        if (!this.focused) {
          this.setDisplayValue();
        }
      }
    },

    methods: {
      /**
       * OnInput event
       */
      onInput(event) {
        this.$emit('input', this.parse(event.target.value));
      },

      /**
       * OnFocus event
       */
      onFocus() {
        this.focused = true;
        this.$emit('focus');
      },

      /**
       * OnBlur event
       */
      onBlur() {
        this.focused = false;
        this.setDisplayValue();
        this.$emit('blur');
      },

      /**
       * OnKeyUp event
       */
      onKeyUp() {
        this.setDisplayValue();
        this.$emit('keyup');
      },

      /**
       * OnChange Event
       */
      setDisplayValue() {
        // IMPORTANT! Wait 1 ms to update
        setTimeout(() => {
          this.$el.value = this.format(this.value);
        }, 1);
        this.$emit('change');
      }
    },

    mounted() {
      // Muestra el valor formateado
      this.setDisplayValue();
    },
  }
</script>



// WEBPACK FOOTER //
// resources/vue/components/CustomInput.vue